import { __assign, __read, __spread, __values } from "tslib";
import { stack } from 'd3-shape';
export var calculateStackData = function (data, labelSelector, keys) {
    var stackedData = stack().keys(keys)(data);
    var newData = stackedData.reduce(function (acc, value) {
        var stackValues = value.map(function (el, idx) {
            var _a, _b;
            var base = __assign(__assign({}, acc[idx]), (_a = {}, _a[labelSelector] = el.data[labelSelector], _a));
            var first = __assign(__assign({}, base), (_b = {}, _b[value.key] = el[1], _b));
            return first;
        });
        return __spread(stackValues);
    }, []);
    if (!keys.length) {
        return data.map(function (el) {
            var _a;
            return (_a = {}, _a[labelSelector] = el[labelSelector], _a);
        });
    }
    return newData;
};
export var calculateStackAreaData = function (data, labelSelector, keys) {
    var stackedData = stack().keys(keys)(data);
    var reduceStack = function (id) { return function (acc, value) {
        var stackValues = value.map(function (el, idx) {
            var _a, _b;
            var base = __assign(__assign({}, acc[idx]), (_a = {}, _a[labelSelector] = el.data[labelSelector], _a));
            var first = __assign(__assign({}, base), (_b = {}, _b[value.key] = el[id], _b));
            return first;
        });
        return __spread(stackValues);
    }; };
    var firstDataPart = stackedData.reduce(reduceStack(0), []);
    var secondDataPart = stackedData.reduce(reduceStack(1), []);
    if (!keys.length) {
        return { firstDataPart: [], secondDataPart: [] };
    }
    return { firstDataPart: firstDataPart, secondDataPart: secondDataPart.reverse() };
};
export var calculateMaxMinSeriesValue = function (data, labelSelector) {
    var keyNamesValues = {};
    return data.reduce(function (acc, serie) {
        var e_1, _a, _b, _c;
        try {
            for (var _d = __values(Object.entries(serie)), _e = _d.next(); !_e.done; _e = _d.next()) {
                var _f = __read(_e.value, 2), key = _f[0], value = _f[1];
                if (key !== labelSelector) {
                    if (acc[key]) {
                        keyNamesValues = __assign(__assign({}, keyNamesValues), (_b = {}, _b[key] = {
                            min: value < acc[key].min ? value : acc[key].min,
                            max: value > acc[key].max ? value : acc[key].max,
                        }, _b));
                    }
                    else {
                        keyNamesValues = __assign(__assign({}, keyNamesValues), (_c = {}, _c[key] = {
                            min: value,
                            max: value,
                        }, _c));
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return __assign(__assign({}, acc), keyNamesValues);
    }, []);
};
